import Model from '@/models/Model'

export default class HrIndicator extends Model {
    resource() {
        return 'hr_indicator'
    }
}